module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "f18 pb20"
  }, [_vm._v("账户信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("账户名：" + _vm._s(_vm.detail.commercial_name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            手机号：\n            "), _c('el-popover', {
    attrs: {
      "placement": "right-start",
      "trigger": "click",
      "content": _vm.decryptStr
    }
  }, [_c('span', {
    staticClass: "primary cursor",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.$utils.decrypt(_vm.detail.mp_encryption, function (res) {
          _vm.decryptStr = res
        })
      }
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.detail.mp))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            账号类型：\n            "), (_vm.detail.type == 1) ? _c('span', [_vm._v("学校")]) : _vm._e(), _vm._v(" "), (_vm.detail.type == 2) ? _c('span', [_vm._v("公司")]) : _vm._e(), _vm._v(" "), (_vm.detail.type == 3) ? _c('span', [_vm._v("加盟")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "line pt10"
  }), _vm._v(" "), _c('p', {
    staticClass: "f18 pb20"
  }, [_vm._v("\n        合作学校\n    ")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "school_name",
      "label": "学校名称",
      "show-overflow-tooltip": true,
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessCode",
      "label": "业务类型",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("校内订餐")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "开通时间",
      "show-overflow-tooltip": true,
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commercialName",
      "label": "公司名称",
      "show-overflow-tooltip": true,
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.detail.commercial_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_cooperate",
      "label": "合作状态",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.is_cooperate == 1 ? '是' : '否'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remit_period",
      "label": "打款周期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "complain_tel",
      "label": "投诉电话",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right-start",
            "trigger": "click",
            "content": _vm.decryptStr
          }
        }, [_c('span', {
          staticClass: "primary cursor",
          attrs: {
            "slot": "reference"
          },
          on: {
            "click": function($event) {
              _vm.$utils.decrypt(scope.row.complain_tel_encryption, function (res) {
                _vm.decryptStr = res
              })
            }
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.complain_tel))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7881a2e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/basic/cooperationInfo.vue
// module id = 882
// module chunks = 0